import React, { createContext, useContext, useState } from 'react'
import { any } from 'prop-types'

const NavContext = createContext()

const NavContextProvider = ({ children }) => {
  const [menuVisible, setMenuVisible] = useState(false)

  const toggleMenu = (override) => {
    if ((override === true || override === false) && menuVisible !== override) {
      setMenuVisible(override)
    } else {
      setMenuVisible((prevState) => !prevState)
    }
  }

  return <NavContext.Provider value={{ menuVisible, toggleMenu }}>{children}</NavContext.Provider>
}

NavContextProvider.propTypes = {
  children: any,
}

const useNavContext = () => {
  const context = useContext(NavContext)
  if (context === undefined) {
    throw new Error('useNavContext must be used within a NavContextProvider')
  }
  return context
}

export { NavContextProvider, useNavContext }
